module.exports = __webpack_public_path__ + "img/baicaoyuan.9d611797.jpg";